import { SET_SELECTED_FEATURED_ITEM } from './mutationTypes';
import { IFilterState } from './types';
import StoreUtil from '@store/StoreUtil';
import { routeNames } from '@src/app/router';
import { Dispatch, Commit } from 'vuex';
import slugify from '@core/utils/url/slugify';
import LottoEvent from '@core/models/lotto/LottoEvent';

export const getters = {
    featuredLottoGames: (state: IFilterState, getters: any, rootState: any, rootGetters: any) =>
        // TODO: fetch featured games trough CMS, not supported for now
        state.availableFeaturedItems,

    featuredFilter(state: IFilterState, getters: any) {
        return (event: LottoEvent) => getters.selectedFeaturedItem === event.lottoId;
    },
    selectedFeaturedItem: StoreUtil.createSimpleGetter('selectedFeaturedItem'),

    _selectedFeaturedGame(state: IFilterState, getters: any) {
        return (gameId: number) => getters.featuredLottoGames.find((g: any) => (g.id === gameId));
    },
};

export const mutations = {
    /*
        The logic of not simultaneous existence of selected featured item and selectedTreeItems
        is enforced in these 2 mutations and not in actions to reduce the chance of it breaking.
        These 2 fields can be basically be considered one field of type  number or number[]
        but checking that would be less clear than this.
    */
    [SET_SELECTED_FEATURED_ITEM](state: IFilterState, selectedFeaturedItem: any) {
        state.selectedFeaturedItem = selectedFeaturedItem;
        state.selectedTreeItems = [];
    },
};

export const actions = {
    selectFeaturedLotteryGame: (
        { dispatch, rootGetters, getters, commit }:
            { dispatch: Dispatch, rootGetters: any, getters: any, commit: Commit },
        gameId: Number | null,
    ) => {
        if (gameId === null) {
            commit(SET_SELECTED_FEATURED_ITEM, gameId);
            return;
        }
        const { timeFilter } = rootGetters['navigation/route'].params;
        const game = getters._selectedFeaturedGame(gameId);
        const params = {
            countrySlug: slugify(game.country),
            gameSlug: slugify(game.name),
        } as any;
        if (timeFilter) {
            params.timeFilter = timeFilter;
        }
        commit(SET_SELECTED_FEATURED_ITEM, gameId);
        dispatch('navigation/replace', { params, name: routeNames.lotteryGame }, { root: true });
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/shared/lotto/filter/featuredFilter.ts